import { AuditType } from '../api';

export const getAuditTypeIcon = (auditType: AuditType): string => {
  switch (auditType) {
    case AuditType.ORDER_CREATED:
    case AuditType.ORDER_CREATED_FROM_VOUCHER:
      return '📝';
    case AuditType.ORDER_UPDATED:
      return '✏️';
    case AuditType.ORDER_DELETED:
      return '🗑️';
    case AuditType.EVENT_CREATED:
      return '📅';
    case AuditType.EVENT_UPDATED:
      return '🔄';
    case AuditType.EVENT_DELETED:
      return '❌';
    case AuditType.ORDER_CONVERTED_TO_VOUCHER:
    case AuditType.VOUCHER_CREATED_FROM_ORDER:
      return '🎁';
    case AuditType.VOUCHER_CONVERTED_TO_ORDER:
      return '🔄';
    case AuditType.PAYMENT_LINK_CREATED:
      return '💳';
    case AuditType.PAYMENT_LINK_PAID:
      return '✅';
    case AuditType.PENDING_ORDER_CONFIRMED:
      return '✅';
    case AuditType.PENDING_ORDER_REJECTED:
      return '❌';
    case AuditType.COURSE_ORDER_CREATED:
      return '📝';
    case AuditType.COURSE_ORDER_PAID:
      return '✅';
    case AuditType.COURSE_ORDER_DELETED:
      return '🗑️';
    case AuditType.ORDER_CREATED_FROM_PASS:
      return '📝';
    case AuditType.PASS_CREATED:
      return '🎫';
    case AuditType.PASS_UPDATED:
    case AuditType.PASS_PUNCHES_ADJUSTED:
      return '✏️';
    case AuditType.PASS_PAUSED:
      return '⏸️';
    case AuditType.PASS_RESUMED:
      return '▶️';
    case AuditType.PASS_ARCHIVED:
      return '🗄️';
    case AuditType.PASS_RENEWED:
      return '🔁';
    case AuditType.PASS_RENEWAL_FAILED:
      return '⚠️';
    case AuditType.PASS_PUNCH_CANCELED:
      return '❌';
    case AuditType.PASS_PUNCH_RESTORED:
      return '↩️';
    case AuditType.PASS_SUBSCRIPTION_CANCELED:
      return '🚫';
    case AuditType.PASS_SUBSCRIPTION_REACTIVATED:
      return '♻️';
    case AuditType.PASS_GUEST_PUNCH_CONSUMED:
      return '👥';
    case AuditType.PASS_GUEST_PUNCH_RESTORED:
      return '👤';
    case AuditType.PASS_SWAPPED:
      return '🔀';
    case AuditType.PASS_SWAP_SCHEDULED:
      return '🗓️';
    case AuditType.PASS_SWAP_CANCELED:
      return '✖️';
    case AuditType.EXTERNAL_VOUCHER_VERIFIED:
      return '✅';
    case AuditType.EXTERNAL_VOUCHER_REJECTED:
      return '🚫';
    case AuditType.CHECKIN_CREATED:
      return '✅';
    case AuditType.CHECKIN_UPDATED:
      return '🔄';
    case AuditType.PROJECT_SELECTION_UPDATED:
      return '🎨';
    case AuditType.EXTRA_PAYMENT_UPDATED:
      return '💵';
    case AuditType.EXTRA_PAYMENT_DELETED:
      return '🗑️';
    case AuditType.REFUND_SUCCEEDED:
      return '💸';
    case AuditType.REFUND_PENDING:
      return '⏳';
    case AuditType.REFUND_FAILED:
      return '⚠️';
    case AuditType.REFUND_BLOCKED:
      return '🚫';
    case AuditType.USER_CREATED:
      return '👤';
    case AuditType.USER_UPDATED:
      return '✏️';
    case AuditType.USER_ROLE_CHANGED:
      return '🔑';
    case AuditType.USER_BLOCKED:
      return '🚫';
    case AuditType.USER_UNBLOCKED:
      return '♻️';
    case AuditType.USER_PASSWORD_RESET:
      return '🔐';
    case AuditType.ORDER_PAGE_UPDATED:
    case AuditType.PASS_ORDER_PAGE_UPDATED:
      return '⚙️';
    case AuditType.ORDER_PAGE_ARCHIVED:
    case AuditType.PASS_ORDER_PAGE_ARCHIVED:
      return '🗄️';
    case AuditType.ORDER_PAGE_RESTORED:
      return '♻️';
    default:
      return '📋';
  }
};
